import {
  LoginRequestDTO,
  LoginResponseDTO,
  SendOTPRequestDTO,
  SignupRequestDTO,
} from './auth.dto'
import apiRequest from '../api'

export const authRoutes = {
  getMe: `/auth/me`,
  signin: `/auth/otp`,
  signup: `/auth/register`,
  signOut: `/auth/logout`,
  login: `/auth/login`,
  googleAuth: `/api/auth/google`,
  facebookAuth: `/api/auth/facebook`,
}

export const sendOTPRequest = ({ email }: SendOTPRequestDTO) =>
  apiRequest<void>(authRoutes.signin, {
    method: 'POST',
    data: { email },
    options: { noAuth: true },
  })

export const loginRequest = (input: LoginRequestDTO) =>
  apiRequest<LoginResponseDTO>(authRoutes.login, {
    method: 'POST',
    data: input,
    options: { noAuth: true },
  })

export const signupRequest = (input: SignupRequestDTO) =>
  apiRequest<LoginResponseDTO>(authRoutes.signup, {
    method: 'POST',
    data: input,
    options: { noAuth: true },
  })

export const signOut = () =>
  apiRequest<void>(authRoutes.signOut, {
    method: 'POST',
    data: {},
  })
